import {NgModule} from '@angular/core';
import {FonteDadosComunicacaoListaComponent} from './fonte-dados-comunicacao-lista/fonte-dados-comunicacao-lista.component';
import {FonteDadosComunicacoService} from './fonte-dados-comunicaco.service';
import {CommonModule} from '@angular/common';
import {AppSharedModule} from '../app-shared.module';

@NgModule({
  imports: [
    AppSharedModule,
    CommonModule
  ],
  declarations: [
    FonteDadosComunicacaoListaComponent
  ],
  exports: [
    FonteDadosComunicacaoListaComponent
  ],
  providers: [
    FonteDadosComunicacoService
  ]
})
export class FonteDadosComunicacaoModule {
}
